import React from "react";

const hocWrapper = Component => props => {
    const { renderControls } = props;
    return (
        <div style={{ position: "relative" }}>
            <Component {...props} />
        </div>
    );
};

export default hocWrapper;
